import initStore from './initStore';
import actions from './actions';
import thunks from './thunks';

import { IAuditLogsModel } from './types';

const auditLogs: IAuditLogsModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default auditLogs;
